import React, { useMemo } from 'react';
import { pick } from 'ramda';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from '../LoginHistory.scss';
import { useDynamicReducerSelector } from '../store';

export const useSummary = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const { totalCount, startDate, endDate } = useDynamicReducerSelector(pick(['totalCount', 'startDate', 'endDate']));
    const endTime = formatter.date(endDate);
    const startTime = formatter.date(startDate);
    const { showTotalLoginCount } = useComponentConfig();
    const totalPeriod = translate('total.between', [startTime, endTime]);

    return useMemo(() => {
        if (!showTotalLoginCount) {
            return null;
        }

        return [
            {
                id: 2,
                isExpandedByDefault: true,
                tableView: {
                    headerCells: [
                        { id: 0, content: translate('total.title') },
                        { id: 1, content: translate('total.count') }
                    ],
                    rowCells: [
                        { id: 0, content: totalPeriod },
                        { id: 1, content: totalCount }
                    ]
                },
                accordionView: {
                    headerCells: [
                        {
                            id: 0,
                            content: (
                                <div className="accordionHeaderSmallDetails">
                                    <span className={style.highlight}>{translate('total.title')}</span>
                                    <span>{totalPeriod}</span>
                                </div>
                            )
                        }
                    ],
                    rowCells: [
                        {
                            id: 0,
                            content: (
                                <>
                                    <div className="accordionBodyCellName">{translate('total.count')}</div>
                                    <div className="accordionBodyCellValue">{totalCount}</div>
                                </>
                            )
                        }
                    ]
                }
            }
        ];
    }, [translate, totalCount, showTotalLoginCount, totalPeriod]);
};
